/* The flags in here should match the public whitelisted flags on the back-end.
   They should only be removed when these flags are removed from the whitelist.
   When removed it means we no longer need to request them in the context of a public route/page.
 */
export const publicFeatureFlagKeys = {
    AuthServerForManagerApiService: 'buildium-auth-server-for-manager-api',
    HaveIBeenPwnedService: 'haveibeenpwned-service-flag',
    TwilioService: 'buildium-twilio-service',
    TwilioSMSService: 'buildium-twilio-sms-service',
    TwilioVoiceService: 'buildium-twilio-voice-service',
    TwilioVerifyApiService: 'twilio-verify-api-for-2fa'
};
